import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@hey-car/ui';
import {
  ErrorBoundarySt,
  ErrorIconSt,
  ErrorMessageSt,
} from './ErrorBoundary.css';
import * as Sentry from '@sentry/react';

const ErrorComponent = () => (
  <ErrorBoundarySt>
    <ErrorIconSt>
      <Icon icon="tools" />
    </ErrorIconSt>
    <ErrorMessageSt>
      <FormattedMessage
        id="shared.errorBoundary.error"
        defaultMessage="Leider ist ein Fehler aufgetreten."
      />
    </ErrorMessageSt>
  </ErrorBoundarySt>
);

export const applyErrorBoundary = (Component) => (props) => (
  <Sentry.ErrorBoundary fallback={ErrorComponent}>
    <Component {...props} />
  </Sentry.ErrorBoundary>
);
